import { render, staticRenderFns } from "./WebPagesContentBoxForm.vue?vue&type=template&id=c1001274&"
import script from "./WebPagesContentBoxForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesContentBoxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports